const alt = require('../alt');
const SubscribeActions = require('../actions/SubscribeActions');

class SubscriptionStore {
    constructor() {
        this.subscriptionConfirm = false;

        this.bindListeners({
            handleShowSubscribed: SubscribeActions.SHOW_SUBSCRIBED,
            handleCloseShowSubscribed: SubscribeActions.CLOSE_SHOW_CONFIRMED
        });
    }

    handleShowSubscribed(responce){
        this.subscriptionConfirm = true;
        setTimeout(SubscribeActions.closeShowConfirmed, 5000);
        this.name = responce;
    }

    handleCloseShowSubscribed(){
        this.subscriptionConfirm = false;
    }
}

module.exports = alt.createStore(SubscriptionStore, 'SubscriptionStore');


// WEBPACK FOOTER //
// ./src/stores/SubscriptionStore.jsx